<template>
  <Menu></Menu>
  <div id="box">
    <div v-if="loading" class="loadingSpinner"><span class="spinner-border"></span></div>
    <!-- =========================================================================================================== -->
    <div class="container mb-2">
      <!-- ----------------------------------------------- -->
      <div class="row p-0">
        <div class="col p-0 text-center">
          <h5 class="fw-bold d-inline-block bi-arrow-left-right">&nbsp; Transfer</h5>
        </div>
        <div class="col-auto p-0 text-center">
          <button class="btn btn-dark w-100 bi-arrow-clockwise" @click="loadTires()" :disabled="loading">&nbsp; Reload</button>
        </div>
      </div>
      <!-- ----------------------------------------------- -->
      <div class="row p-0">
        <div class="col p-0">
          <hr>
        </div>
      </div>
      <!-- ----------------------------------------------- -->
      <div class="row p-0">

        <div class="col-3 p-0">
          <div class="input-group w-100">
            <span class="input-group-text w-25">From</span>
            <select class="form-select" v-model="transferOrder.src_branch" @change="branchChanged()" :disabled="loading">
              <option v-for="b in branches" :key="b._id" :value="b._id">{{ b.name }}</option>
            </select>
          </div>
        </div>

        <div class="col-3">
          <div class="input-group w-100">
            <span class="input-group-text w-25">To</span>
            <select class="form-select" v-model="transferOrder.dst_branch" :disabled="loading">
              <option v-for="b in branches_filtered" :key="b._id" :value="b._id">{{ b.name }}</option>
            </select>
          </div>
        </div>
        
        <div class="col p-0">
          <div class="input-group w-1002">
            <span class="input-group-text w-25">Tires</span>
            <Select2 id="tire" :options="tires" :settings="tires_select2_settings" @select="tireSelected($event)"/>
          </div>
        </div>
      
      </div>
    </div>
    <!-- =========================================================================================================== -->
    <table class="table table-sm table-bordered table-striped table-hover table-fixed">
      <!-- ----------------------------------------------- -->
      <thead>
        <tr class="table-dark">
          <th class="">Product</th>
          <th class="w-15 text-center">Quantity</th>
          <th class="text-center w-20"><span class="bi-gear"></span></th>
        </tr>
      </thead>
      <!-- ----------------------------------------------- -->
      <tbody style="height: calc(100vh - 390px)">        
        <tr v-for="item, index in transferOrder.items" :key="index">
          <td class="position-relative">
            {{ item.name }}
            <span class='subtitle'>Production Date: {{ item.prod_date }}</span>
          </td>
          <td class="w-15 text-center">{{ item.quantity }}</td>
          <td class="dropstart text-center w-20">
            <button class='btn btn-success bi-plus-lg px-2 mx-1' @click="incItem(index)" :disabled="loading"></button>
            <button class='btn btn-warning bi-dash-lg px-2 mx-1' @click="decItem(index)" :disabled="loading"></button>
            <button class='btn btn-danger bi-trash px-2 mx-1' @click="delItem(index)" :disabled="loading"></button>
          </td>
        </tr>
      </tbody>
      <!-- ----------------------------------------------- -->
    </table>
    <!-- =========================================================================================================== -->
    <div class="container p-0">
      <div class="row p-0">
        <div class="col p-0">
          <hr class="">
        </div>
      </div>

      <div class="row p-0">
        <div class="col p-0">
          <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Driver</span>
              <input class="form-control" type="text" v-model.trim="transferOrder.driver">
            </div>
        </div>
        <div class="col">
        </div>
        <div class="col p-0">
          <button class="btn btn-success w-100" @click="transferAction()" :disabled="loading">
            <span class="bi-check-lg">&nbsp; Confirm Transfer</span>
          </button>
        </div>
      </div>

      <div class="row p-0">
        <div class="col p-0">
          <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Truck</span>
              <input class="form-control" type="text" v-model.trim="transferOrder.truck">
            </div>
        </div>
        <div class="col">
        </div>
        <div class="col p-0">
        </div>
      </div>

      <div class="row p-0">
        <div class="col p-0">
          <div class="input-group w-100 mb-2">
            <span class="input-group-text w-25">Fees</span>
            <input class="form-control" type="number" v-model.number="transferOrder.fees">
          </div>
        </div>
        <div class="col">
        </div>
        <div class="col p-0">
        </div>
      </div>


    </div>
    <!-- =========================================================================================================== -->
    <div id="addModal" ref="addModal" class="modal fade">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title">Edit Tire: {{ currProduct.name }}</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body text-center">
            <table class="table table-sm table-bordered">
              <thead>
                <tr class="table-secondary">
                  <th>Branch</th>
                  <th>Prod Date</th>
                  <th class="text-center">Quantity</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="x in currProduct.quantities" :key="x._id">
                  <th>{{ x.branch }}</th>
                  <th>{{ x.prod_date }}</th>
                  <th>{{ x.quantity }}</th>
                </tr>
              </tbody>
            </table>

            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-50">Production Date</span>
              <select class="form-select" v-model="currProduct.prod_date">
                <option v-for="x in currProduct.quantities" :key="x._id" :value="x.prod_date">{{ x.prod_date }}</option>
              </select>
            </div>

            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Amount</span>
              <input class="form-control" type="number" v-model.number="currProduct.amount">
            </div>

          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-footer">
            <div class="container">
              <div class="row">
                <div class="col">
                  <a class="btn btn-secondary w-100" data-bs-dismiss='modal'>Cancel</a>
                </div>
                <div class="col">
                  <button class="btn btn-success w-100" @click="addItem()" :disabled="loading">Add</button>
                </div>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
    <!-- =========================================================================================================== -->
    <!-- =========================================================================================================== -->
  </div>
</template>
<!-- ******************************************************** -->
<script>
  const $ = require('jquery');
  export default {
    name: 'TransferPage',
    data(){
      return {
        loading: false,

        branches: [],
        tires: [],

        //----------------------------------
        currProduct:{
          _id: '',
          name: '',
          prod_date: '',
          quantities: [],
          amount: 0,
        },
        //----------------------------------
        transferOrder:{
          src_branch: '',
          dst_branch: '',
          driver: '',
          truck: '',
          fees: '',
          notes: '',
          items: [],
        },
        //----------------------------------
        tires_select2_settings:{
          theme: "bootstrap-5",
          placeholder: 'Search for Products',
          width: '320px',
          matcher: (params, data)=>{
            if(!params.term || !params.term.trim()) return data;
            if(data.text.toLowerCase().includes(params.term.toLowerCase())) return data;
            if(data.barcode && data.barcode.includes(params.term)) return data;
            return null;
          }
        },
      }
    },
    async created() {
      await this.loadBranches();
      if(this.branches.length > 1) this.transferOrder.src_branch = this.branches[0]._id;
      await this.loadTires();
    },
    //**********************************************************
    computed:{
      branches_filtered(){
        return this.branches.filter((x)=> x._id != this.transferOrder.src_branch);
      }
    },
    //**********************************************************
    methods:{
      //**********************************************************
      async loadBranches(){
        this.loading = true;
        this.branches = [];
        var ack = await this.$service.getBranchesAbstract();
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.branches = ack.data;
        }
        this.loading = false;
      },
      //**********************************************************
      async loadTires(){
        this.loading = true;

        this.tires = [];
        var ack = await this.$service.getTiresAbstract();
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.tires = ack.data;
        }
        this.loading = false;
      },
      //**********************************************************
      async tireSelected({id, text}){
        this.currProduct._id = id;
        this.currProduct.name = text;
        $('#tire').val(null).trigger('change');
        if(!this.transferOrder.src_branch) return this.$toast('Select a source branch first');
        // if(!this.transferOrder.dst_branch) return this.$toast('Select a destination branch first');
        this.loading = true;
        var ack = await this.$service.getStockDetails({
          branch: this.transferOrder.src_branch,
          product: id,
        });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.currProduct.quantities = ack.data;
          this.currProduct.prod_date = this.currProduct.quantities.length ? this.currProduct.quantities[0].prod_date : '';
          this.currProduct.amount = 0;
        }
        this.loading = false;
        if(!ack.data.length){
            this.$toast('No Enough Stock');
        }
        else{
          $('#addModal').modal('show');
        }
      },
      //**********************************************************
      async addItem(){
        if(this.currProduct.amount <= 0) return this.$toast('Invalid Amount');

        this.loading = true;

        var index = this.transferOrder.items.findIndex((x)=>x._id == this.currProduct._id && x.prod_date == this.currProduct.prod_date );
        var needed = (index < 0) ? this.currProduct.amount : this.transferOrder.items[index].quantity + this.currProduct.amount;
        var ack = await this.$service.checkStock({ 
          branch: this.transferOrder.src_branch,
          product: this.currProduct._id,
          prod_date: this.currProduct.prod_date,
          amount: needed,
        });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else if(!ack.data){
          this.$toast('No Enough Stock');
        }
        else{
          if(index < 0){
            this.transferOrder.items.push({
              _id: this.currProduct._id,
              name: this.currProduct.name,
              prod_date: this.currProduct.prod_date,
              quantity: this.currProduct.amount,
            });
          }
          else{
            this.transferOrder.items[index].quantity += this.currProduct.amount;
          }
        }

        this.loading = false;
        $('#addModal').modal('hide');
      },
      //**********************************************************
      async incItem(index){
        this.loading = true;
        
        var ack = await this.$service.checkStock({ 
          branch: this.transferOrder.src_branch,
          product: this.transferOrder.items[index]._id,
          prod_date: this.transferOrder.items[index].prod_date,
          amount: this.transferOrder.items[index].quantity + 1,
        });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else if(!ack.data){
          this.$toast('No Enough Stock');
        }
        else{
          this.transferOrder.items[index].quantity += 1;
        }
        this.loading = false;
      },
      //**********************************************************
      async decItem(index){
        this.transferOrder.items[index].quantity -= 1;
        if(this.transferOrder.items[index].quantity == 0){
          this.transferOrder.items.splice(index, 1);
        }
      },
      //**********************************************************
      async delItem(index){
        this.transferOrder.items.splice(index, 1);
      },
      //**********************************************************
      async transferAction(){
        this.loading = true;
        await this._transferAction();
        this.loading = false;
      },
      //**********************************************************
      async _transferAction(){
        if(!this.transferOrder.src_branch){
          return this.$toast('Select a source branch', 'warning');
        }
        if(!this.transferOrder.dst_branch){
          return this.$toast('Select a destination branch', 'warning');
        }
        if(!this.transferOrder.items.length){
          return this.$toast('No items to transfer', 'warning');
        }
        var ack = await this.$service.transfer(this.transferOrder);
        if(ack.state != 'OK'){
          return this.$toast(ack.state);
        }
        else{
          this.resetFields();
        }
        this.$toast('Transfer Placed', 'success');
      },
      //**********************************************************
      async branchChanged(){
        this.transferOrder.items = [];
      },
      //**********************************************************
      async resetFields(){
        this.transferOrder = {
          src_branch: this.branches[0]._id,
          dst_branch: '',
          driver: '',
          truck: '',
          fees: '',
          notes: '',
          items: [],
        }
      }
      //**********************************************************
      //**********************************************************
      //**********************************************************
    }
  }
</script>
<!-- ******************************************************** -->
<style scoped>
#stockDetailsPieChartContainer{
    width: 100% !important;
    height: 200px !important;
}
#stockDetailsPieChart{
    max-width: 100% !important;
    height: 200px !important;
}
</style>
  